import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Coins, Zap } from 'lucide-react';

export default function MobileUtilityMenu() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    // onClose();
    setTimeout(() => navigate(path), 100);
  };

  const utilities = [
    {
      title: 'Giá vàng & Ngoại tệ',
      icon: <Coins className="w-20 h-20 text-yellow-500" />,
      path: '/utilities/mobile-gold-currency',
    },
    {
      title: 'Lịch cúp điện',
      icon: <Zap className="w-20 h-20 text-vietnam-primary" />,
      path: '/utilities/mobile-power',
    },
  ];

  return (
    <div className="px-4 pt-4 pb-6">
      <div className="grid grid-cols-2 gap-4">
        {utilities.map((item, index) => (
          <button
            key={index}
            onClick={() => handleNavigate(item.path)}
            className="aspect-square w-full bg-white rounded-xl shadow flex flex-col items-center justify-center hover:bg-gray-100 transition"
          >
            {item.icon}
            <span className="mt-4 text-sm font-medium text-gray-800 text-center leading-tight">
              {item.title}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
